import { IJob } from '@medely/types';
import { ShiftRequest, ShiftRequestKinds, ShiftRequestStatus } from '@mp/graphql/generated/graphql';
import { jobBonusCents } from '@mp/utils';

export const useRateRequest = (job: IJob) => {
  const jobBonusPayRate = jobBonusCents(job);
  const currentTotalJobPayRateCents =
    (job.job_billing_sums?.payout_total_amount_cents ?? 0) + jobBonusPayRate;

  // @ts-ignore - until we add codegen to job query
  const rateChangeRequests: ShiftRequest[] | undefined = job?.professional_shift_requests?.filter(
    (r: ShiftRequest) => r.request_kind === ShiftRequestKinds.RateChange,
  );

  const mostRecentRateRequest: ShiftRequest | undefined = [...(rateChangeRequests ?? [])]
    ?.sort(
      (a: ShiftRequest, b: ShiftRequest) =>
        new Date(b.submitted_at).getTime() - new Date(a.submitted_at).getTime(),
    )
    ?.shift();

  const isMostRecentRateRequestApproved =
    mostRecentRateRequest?.status === ShiftRequestStatus.Approved;
  const isCurrentTotalJobPayRateGreaterThanRequestedRate =
    currentTotalJobPayRateCents >=
    (mostRecentRateRequest?.transformation_data?.requested_payout_total_cents ?? 0);

  const hasApprovedRateRequest =
    isMostRecentRateRequestApproved && isCurrentTotalJobPayRateGreaterThanRequestedRate;
  const hasPendingRequest = mostRecentRateRequest?.status === ShiftRequestStatus.Pending;

  const hasReachedMaxRequests = (rateChangeRequests?.length ?? 0) >= 2;

  const shouldDisplayAdditionalRateOptionsButton =
    !hasApprovedRateRequest && !hasReachedMaxRequests;
  const isAdditionalRateOptionsButtonDisabled = hasPendingRequest;

  const shouldDisplayRateRequestBanner =
    isMostRecentRateRequestApproved && !isCurrentTotalJobPayRateGreaterThanRequestedRate
      ? false
      : !!mostRecentRateRequest;
  const shouldDisplayRateRequestBadge = shouldDisplayRateRequestBanner;

  return {
    listRateChangeRequests: rateChangeRequests,
    mostRecentRateRequest,
    shouldDisplayAdditionalRateOptionsButton,
    hasApprovedRateRequest,
    isMostRecentRateRequestApproved,
    oldRateCents: mostRecentRateRequest?.transformation_data?.original_payout_total_cents ?? 0,
    newRateCents: currentTotalJobPayRateCents,
    shouldDisplayRateRequestBanner,
    shouldDisplayRateRequestBadge,
    isAdditionalRateOptionsButtonDisabled,
  };
};
